module.exports = __webpack_public_path__ + "img/certificadoM3.7d2f110e.png";